export const isProd = true;

export const API_URL = isProd 
  ? 'https://api.oak-us.com'  
  : 'http://localhost:5000';

export default API_URL;